import React, { useState, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import LoadingSpinner from '../components/LoadingSpinner';

const AuthPage = () => {
    const [isLogin, setIsLogin] = useState(true);
    const emailRef = useRef();
    const passwordRef = useRef();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { signup, login } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        const email = emailRef.current.value;
        const password = passwordRef.current.value;

        try {
            if (isLogin) {
                await login(email, password);
            } else {
                await signup(email, password);
            }
        } catch (err) {
            setError(err.message.replace('Firebase: ', ''));
        }

        setLoading(false);
    };

    const toggleAuthMode = () => {
        setIsLogin(prevIsLogin => !prevIsLogin);
        setError('');
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-950">
            <div className="w-full max-w-md p-8 space-y-6 bg-gray-900 shadow-xl">
                <h2 className="text-3xl font-bold text-center text-white">{isLogin ? 'Log In' : 'Sign Up'}</h2>
                {error && <p className="text-center text-red-500 bg-red-100 p-3">{error}</p>}
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <input
                            type="email"
                            placeholder="Email Address"
                            ref={emailRef}
                            required
                            className="w-full p-3 bg-gray-700 border border-gray-600 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#e50914]"
                        />
                    </div>
                    <div>
                        <input
                            type="password"
                            placeholder="Password"
                            ref={passwordRef}
                            required
                            className="w-full p-3 bg-gray-700 border border-gray-600 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#e50914]"
                        />
                    </div>
                    <div>
                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full bg-[#e50914] hover:bg-[#b0060f] text-white font-bold py-3 px-6 transition duration-300 ease-in-out disabled:bg-gray-500"
                        >
                            {loading ? <LoadingSpinner size="h-6 w-6" /> : (isLogin ? 'Log In' : 'Sign Up')}
                        </button>
                    </div>
                </form>
                <div className="text-center">
                    <button onClick={toggleAuthMode} className="text-sm text-gray-400 hover:text-white hover:underline">
                        {isLogin ? "Need an account? Sign Up" : "Have an account? Log In"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AuthPage; 